// eslint-disable-next-line workspaces/require-dependency
import { getBraintreeClientToken } from '@atlassian/temp-proxies';
import braintree from 'braintree-web';
import type { PayPalCheckout } from 'braintree-web/paypal-checkout';

export const initiatePaypalSDK = async (): Promise<PayPalCheckout> => {
  const { token } = await getBraintreeClientToken();

  return new Promise((resolve, reject) => {
    braintree.client
      .create({
        authorization: token as string,
      })
      .then((clientInstance) => {
        return braintree.paypalCheckout.create({
          client: clientInstance,
        });
      })
      .then((paypalCheckoutInstance) => {
        return paypalCheckoutInstance.loadPayPalSDK({
          vault: true,
        });
      })
      .then((paypalSDK) => {
        resolve(paypalSDK);
      })
      .catch((error) => reject(error));
  });
};
